/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Register default components
Vue.component('default-navigation', require('./components/defaults/Navigation.vue').default);
Vue.component('default-footer', require('./components/defaults/Footer.vue').default);

// Router
import router from './routes';
window.router = router;

router.beforeEach((to, from, next) => {
    next((vm) => {
        vm.$root.loading = true;
    })
})

router.afterEach((to, from) => {
    if(document.querySelector('.tooltip.fade.show')) {
        document.querySelectorAll('.tooltip.fade.show').forEach(el => el.remove());
    }
});

import store from './store/store';

const app = new Vue({
    el: '#app',
    data: {loading:false},
    router,
    store,
    beforeCreate() {
        this.$store.commit('results/initialiseStore');
    }
}).$mount('#app');
